import { useAuth } from "@/hooks/useAuth";
export function AccountPage() {
  const { user } = useAuth();
  return (<div><h1>Mon compte</h1><div>{user?.username}</div></div>);
}
